interface IPauseGlyphProps {
  className?: string;
}

/** Two-bar pause glyph — `@orn/shared-web/icons` has none. Inherits `currentColor`. */
const PauseGlyph = ({ className }: IPauseGlyphProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.6"
    strokeLinecap="round"
    aria-hidden="true"
    className={className}
  >
    <path d="M9 5v14M15 5v14" />
  </svg>
);

export default PauseGlyph;
